<div class="banner__inner">
  <ng-content></ng-content>
</div>
